<template>
  <b-modal v-model="open" @hide="onclose" hide-footer hide-header body-class="as24-auth-modal">
		
    <div style="height: 700px">
      <iframe
        id="as24-authorization-dialog-iframe"
        class="w-100 h-100 border-0"
        :src="uri"
        @load="loading = false"
        @success="onsuccess"
      />
      <b-spinner label="Spinning" v-if="loading"></b-spinner>
    </div>
  </b-modal>
</template>

<script>
/* eslint-disable camelcase */
import { vSync } from '@/util/mixins';
import { toListString } from '@/util/helper';

const URI = 'https://api.autoscout24.com/auth/oauth/v2/authorize?';

const URI_PARAMS = {
  response_type: 'code',
  client_id: 'e2867471-0bd6-415e-a20d-269879e537dc',
  redirect_uri: 'https://api.autengo.com/v2/as24hooks/carlisting',
};

export class AuthorizationCanceledError extends Error { }

export default {
  name: 'As24AuthorizationDialog',
  props: ['defer'],
  mixins: [vSync('open')],
  data() {
    return {
      uri: URI + toListString(URI_PARAMS, '&', encodeURIComponent),
      loading: true,
    };
  },
  methods: {
    onsuccess() {
      this.defer && this.defer.resolve();
      this.open = false;
    },
    onclose() {
      this.loading = true;
      this.defer && this.defer.reject(
        new AuthorizationCanceledError('The AS24 Authorization is canceled by the user!'),
      );
    },
  },
};
</script>

<style>
.as24-auth-modal {
	padding: 1px !important;
}
</style>
